import { render, staticRenderFns } from "./braces-reissue-table.vue?vue&type=template&id=797b236b&scoped=true"
import script from "./braces-reissue-table.vue?vue&type=script&lang=js"
export * from "./braces-reissue-table.vue?vue&type=script&lang=js"
import style0 from "./braces-reissue-table.vue?vue&type=style&index=0&id=797b236b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b236b",
  null
  
)

export default component.exports